import { Checkbox, Stack } from "@mantine/core";
import React from "react";
import { useCalendar } from "src/components/calendar/CalendarContext";
import { useActions, useAppState } from "src/state";
import { User_Type_Enum } from "src/state/gql/_types";

export const OperationsAdminVenueBookingCalendarTalentFilter: React.FC<{}> = () => {

    const { itemsList, loading } = useAppState(state => state.users)
    const getAllItems = useActions().users.getAllItems
    const { talentFilter, setTalentFilter } = useCalendar()
    const { tenant_id: currentTenantId } = useAppState(state => state.auth)

    React.useEffect(() => {
        getAllItems({
            where: {
                type: { _eq: User_Type_Enum.Talent },
                tenant_id: { _eq: currentTenantId }
            }
        })
    }, [])

    if (loading) return <span>Loading...</span>

    const allSelected = talentFilter.length === 0
    const someSelected = talentFilter.length > 0 && talentFilter.length < itemsList.length

    const handleAllTalentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (allSelected) {
            event.preventDefault()
        } else {
            setTalentFilter([])
        }
    }

    return (
        <Stack gap="xs">

            <Checkbox
                label="All Talent"
                checked={allSelected}
                indeterminate={someSelected}
                onChange={handleAllTalentChange}
            />

            <Stack gap="xs">
                {itemsList.map((user) => (
                    <Checkbox
                        key={user.id}
                        value={user.id}
                        label={user.dj_display}
                        color={user.color||'dark'}
                        onChange={(event) => {
                            const checked = event.currentTarget.checked
                            if (checked) {
                                setTalentFilter(talentFilter.filter(id => id !== user.id))
                            } else {
                                if (talentFilter.length !== itemsList.length - 1) {
                                    setTalentFilter([...talentFilter, user.id])
                                }
                            }
                        }}
                        checked={allSelected ? true : !talentFilter.includes(user.id)}
                    />
                ))}
            </Stack>

        </Stack>
    )

}